export class GetTrophies {
    public static readonly type = '[Trophies] Get trophies';

    constructor() {}
}
